import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map } from 'rxjs';
import { VideoModel } from '../../models';
import { VIDEOS_API_URL } from '../../tokens';

@Injectable()
export class VideosService {
  private readonly baseUrl = inject(VIDEOS_API_URL);
  private readonly httpClient = inject(HttpClient);

  public get featuredVideos$() {
    return this.httpClient
      .get<VideoModel[]>(`${this.baseUrl}/videos/featured`)
      .pipe(
        map(response => {
          response.forEach((video: VideoModel) => {
            video.thumbnail = `${this.baseUrl}/events/image?sourceUrl=${encodeURIComponent(video.thumbnail)}`;
          });

          return response;
        })
      );
  }
}
